import styled from '@emotion/styled';
import { DetailList as DetailListComponent } from '@presentation/components/DetailList';
import { mediaQuery, mediaQueryBetween } from '@presentation/styles';

export const Wrapper = styled.div`
  background: ${(props) => props.theme.color.light.default};
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
`;

export const DetailList = styled(DetailListComponent)`
  &:not(:last-child) {
    margin-bottom: 30px;
  }
  flex-grow: 1;
  text-align: left;
`;

export const ButtonContainer = styled.div`
  /* width: auto; */
  margin-left: auto;
  /* ${mediaQuery('header')} { */
  width: 100%;
  /* } */
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  display: block;
  /* width: 265px; */
  /* ${mediaQuery('tablet')} { */
  width: 100%;
  /* }
  ${mediaQueryBetween('tablet', 'header')} {
    display: inline-block;
    width: calc(${100 / 3}% - 20px);
    margin-right: 20px;
  } */
`;
